import { Box } from 'shared/ui/Box';
import { SearchBlockStyled, SearchItemStyled } from 'shared/ui/search/styled';
import { Skeleton } from 'shared/ui/Skeleton';

const skeletonArray = Array(5).fill(null);

export const SearchSkeleton = () => (
  <SearchBlockStyled>
    {skeletonArray.map((_, idx) => (
      <SearchItemStyled key={idx}>
        <Skeleton size={50} />
        <Box display='flex' flexDirection='column' ml={4}>
          <Skeleton display='flex' flexDirection='column' mt={2} />
          <Box display='flex'>
            <Skeleton mt={2} />
            <Skeleton mt={2} ml={2} />
          </Box>
        </Box>
      </SearchItemStyled>
    ))}
  </SearchBlockStyled>
);
